import * as Turf from "@turf/turf";
import {
  TLatLong,
  TNotamCoordinates,
} from "@naviair-utm/node-shared-interfaces";

export const generateGeoJSON = (
  geoInput: TNotamCoordinates[],
  radius?: number
) => {
  //Point
  if (
    (geoInput.length == 3 && geoInput[0] !== geoInput[geoInput.length - 1]) ||
    geoInput.length > 3
  ) {
    let polygonArray: TLatLong[] = geoInput.map((value) => {
      const lat = value.latLng[0];
      const long = value.latLng[1];
      return [long, lat];
    });
    //Push first entry to last for GeoJSON support if needed.
    // Check if first and last element in array is equal (index 0 and 1) and push first element if not
    if (
      !(
        polygonArray[0][0] === polygonArray[polygonArray.length - 1][0] &&
        polygonArray[0][1] === polygonArray[polygonArray.length - 1][1]
      )
    ) {
      polygonArray.push([geoInput[0].latLng[1], geoInput[0].latLng[0]]);
    }

    // Filter polygonArray so that not two consecutive coordinates are the same
    polygonArray.filter((current, i, arr) => {
      if (i === 0) return;
      const previous = arr[i - 1];
      return !(current[0] === previous[0] && current[1] === previous[1]);
    });

    const polygon = Turf.polygon([polygonArray]);
    return polygon.geometry;
  } else {
    const lat = geoInput[0].latLng[0];
    const long = geoInput[0].latLng[1];

    if (radius !== 999) {
      const circle = Turf.circle([long, lat], radius, {
        units: "nauticalmiles",
      });
      return circle.geometry;
    } else {
      const point = Turf.point([long, lat]);
      return point.geometry;
    }
  }
};
